import RestClient from '@op/luna.yaweb-common-js/RESTClient';
import { Card } from '@op/titan.insurance-ecard-js/';

const proxyBasePath = '/proxy/policies/ecards/info/v3';

const defaultHeaders = {
    Accept: 'application/json',
};

class RestApi extends RestClient {
    constructor() {
        // Rest URL is set in index.html so RD can modify it
        super((window as any).ECARD_INFO_API_ROOT);
    }

    getCard = (cardId: string, language: string | undefined): Promise<Card> =>
        this.Api.get('{proxyBasePath}/ecards/{cardId}', {
            pathParams: {
                proxyBasePath: proxyBasePath,
                // backend expects uppercase and some browsers convert to lowercase
                cardId: cardId.toUpperCase(),
            },
            query: { lang: language || '' },
            headers: defaultHeaders,
        });
}

const restApi = new RestApi();
export default restApi;
